<template>
  <a-spin :spinning="pageLoading" tip="Loading...">
    <a-card>
      <div slot="title">
        <h4 class="margin-remove">Create Bank Reconciliation</h4>
      </div>
      <ul class="m-list-wrapper bordered">
        <li>
          <span class="m-list-title" for>Bank</span>
          <span class="m-list-desc">
            <div style="display:flex;align-items: center;">
              <img :src="urllogo + 'assets/bank/' +
                (datasource.data_header.logo_bank ? datasource.data_header.logo_bank : '#')" style="max-width:100px"
                v-bind:onerror="'this.src=' + urllogonotfound">
              &nbsp;
              {{ datasource.data_header.nama_bank }} ({{ datasource.data_header.bank_account_id }})
            </div>
          </span>
        </li>
        <li>
          <span class="m-list-title" for>Owner</span>
          <span class="m-list-desc">
            {{ datasource.data_header.pemilik ?
              datasource.data_header.pemilik : '-' }} ({{ datasource.data_header.kode_rekening }})
          </span>
        </li>
      </ul>
    </a-card>
    <a-row :gutter="24">
      <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
        <a-card class="margin-top">
          <div slot="title" class="margin-remove m-display-flex align-middle" style="align-items: flex-start;">
            <h4 class="margin-remove">Reconciliation Transaction</h4>
            <div>
              <a-tag v-if="!closetrans" :color="stspass == 'MATCH' ? 'green' : 'red'"
                :style="stspass == 'MATCH' ? 'margin-left:0.5em;color:green' : 'margin-left:0.5em;color:red'">{{ stspass
                }}</a-tag>
              <a-tag v-else :color="'grey'" :style="'margin-left:0.5em;color:white'">CLOSED</a-tag>
            </div>
          </div>
          <a-form-model ref="form1" :model="form1" :rules="rules1">
            <a-row :gutter="24">
              <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
                <a-form-model-item ref="periode" label="Select Periode" prop="periode">
                  <a-month-picker placeholder="Select Date" :format="'MM-YYYY'" picker="month" :allowClear="false"
                    :disabled-date="disabledMinDate" v-model="form1.select_periode" @change="handleChangePeriode" />
                </a-form-model-item>
              </a-col>
              <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
                <a-form-model-item ref="trans_date" label="Transaction Date" prop="trans_date">
                  <a-date-picker placeholder="Select Date" :format="'DD-MM-YYYY'" :allowClear="false"
                    :disabled="(bank_rekonsiliasi_hdr_id != null && form1.start_balance > 0) || closetrans || isFc"
                    :disabled-date="disabledTrans_date" v-model="form1.trans_date" />
                </a-form-model-item>
              </a-col>
              <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
                <a-form-model-item ref="start_balance" label="Start balance" prop="start_balance">
                  <a-input-number v-model="form1.start_balance" @keydown="currencyIndonesianFormat"
                    :disabled="disabledstartbalance || closetrans || isFc" :formatter="formatterIndonesianCurrency"
                    :parser="parserIndonesianCurrency"
                    :class="!getScreen ? 'margin-remove m-width-full' : 'margin-top m-width-full'"
                    placeholder="Input Start Balance" />
                </a-form-model-item>
              </a-col>
              <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
                <a-form-model-item ref="reference_balance" label="Reference balance" prop="reference_balance">
                  <a-input-number v-model="form1.reference_balance" @keydown="currencyIndonesianFormat"
                    :disabled="(bank_rekonsiliasi_hdr_id != null && form1.start_balance > 0) || closetrans || isFc"
                    :formatter="formatterIndonesianCurrency" :parser="parserIndonesianCurrency"
                    :class="!getScreen ? 'margin-remove m-width-full' : 'margin-top m-width-full'"
                    placeholder="Input Referance balance" />
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-form-model>
          <template class="ant-card-actions" #actions v-if="!isFc">
            <div class="m-display-flex">
              <a-button @click="handleSet" type="primary" :disabled="closetrans">
                {{ action_label }}
              </a-button>
              <a-button @click="handleCloseReconsile" class="margin-left" type="danger"
                :disabled="stspass !== 'MATCH' || datasource.file_attachment.length == 0 || closetrans || isFc"
                :loading="loadingclose">Close</a-button>
            </div>
          </template>
        </a-card>
      </a-col>
      <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
        <!-- <a-card title="Status">
          <template slot="extra">
            <a-tag color="green">Created</a-tag>
          </template>
          <h4 class="margin-remove">
            {{
              `Pembuat - ${
                datasource.data_header ? datasource.data_header.tlc_create : "-"
              }`
            }}
          </h4>
          --          <small>{{ datasource.data_header.create_dt }}</small>--
          <small>{{
            moment(
              datasource.data_header ? datasource.data_header.create_dt : null
            ).format(getDateTimeFormat)
          }}</small>
        </a-card> -->
        <a-collapse :class="'margin-top'" activeKey="1">
          <a-collapse-panel key="1" :disabled="true">
            <div class="m-display-flex space-between align-middle" slot="header">
              <h4 class="margin-remove">
                Attachment
                <span>[{{ moment(form1.select_periode).format("MM-YYYY") }}]</span>
              </h4>
              <a-button type="default" size="small" class="margin-right-small" @click="handleupload"
                :disabled="bank_rekonsiliasi_hdr_id == null || stspass != 'MATCH'"
                v-if="!isFc"
                >
                <a-icon type="upload" />
                Upload
              </a-button>
            </div>
            <div style="height: 145px;max-height:145px;overflow-y:auto">
              <a-list itemLayout="horizontal" :dataSource="datasource.file_attachment">
                <Empty v-if="datasource.file_attachment
                  ? datasource.file_attachment.length <= 0
                  : datasource.file_attachment
                  " />
                <a-list-item slot="renderItem" slot-scope="item, index">
                  <a-list-item-meta>
                    <div slot="title" class="m-display-flex space-between align-top">
                      <span>
                        {{ index + 1 }}. {{ item.description }}
                      </span>
                      <!-- <a-button type="primary" size="small" icon="eye" @click="handleviewfile(item.file_url)">
                          view
                        </a-button> -->
                    </div>
                    <template slot="description">
                      <!-- <span>{{ item.create_dt }}</span> -->
                      <a-button-group>
                        <a-button type="primary" size="small" icon="eye" @click="handleviewfile(item.file_url)" :disabled="isFc"
                          style='float: right;'>
                          View
                        </a-button>
                        <a-button @click="handleRemoveExisting(item.bank_rekonsiliasi_doc_id)" size="small" type="danger"
                          icon="delete" :disabled="closetrans || stspass != 'MATCH' || isFc">Delete</a-button>
                      </a-button-group>
                    </template>
                    <a-divider class="margin-small" />

                  </a-list-item-meta>
                </a-list-item>
              </a-list>
            </div>
          </a-collapse-panel>
        </a-collapse>
      </a-col>
    </a-row>
    <a-collapse :class="'margin-top'" :default-active-key="2">
      <a-collapse-panel key="1">
        <div class="m-display-flex space-between align-middle" slot="header">
          <h4 class="margin-remove">
            BKK Not Realized</h4>
          <!-- <a-button
            type="default"
            size="small"
            class="margin-right-small"
            @click="handleupload"
            :disabled="bank_rekonsiliasi_hdr_id==null"
          >
            <a-icon type="upload" />
            Upload
          </a-button> -->
        </div>
        <div>
          <a-row :gutter="24">
            <a-col :xs="{ span: 24 }" :lg="{ span: 24 }">
              <a-input-search v-model="searchBkk" :class="!getScreen ? 'margin-remove' : 'margin-top'"
                placeholder="Search BKK Not Realized .. " />
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :xs="{ span: 24 }" :lg="{ span: 24 }">
              <a-config-provider :locale="getLocalConfigProvider()">
                <a-table :rowKey="(record, index) => { return index; }" key="bkktable" size="small" class="margin-top"
                  bordered :scroll="{ x: 800 }" :columns="columnsBKKNotReleazed" :dataSource="databkknotrealizedtmp"
                  :loading="loading">
                  <template slot="bkknotrealizedNumber" slot-scope="data">
                    <span>{{ moment(data.create_dt).format(getDefaultDateFormat) }}</span><br />
                    <span>{{ data.jenis }}</span><br />
                    <a @click="handlelinkmanifest(data.bkk_id, data.jenis)">{{ data.no_bkk }}</a>
                  </template>
                  <template slot="value" slot-scope="data">
                    <CurrencyJustified :currencyValue="datasource.data_header.currency" :valueNumber="data.value_bkk" />
                  </template>
                  <template slot="duedate" slot-scope="data">
                    {{ data.jatuh_tempo_dt ? moment(data.jatuh_tempo_dt).format(getDefaultDateFormat) : '-' }}
                  </template>
                  <template slot="act" slot-scope="text, data">
                    <a-button-group>
                      <a-button type="primary" @click="handleeditRealization(data)" icon="edit"
                        :disabled="bank_rekonsiliasi_hdr_id == null || closetrans || isFc">
                        Update Realization
                      </a-button>
                    </a-button-group>
                  </template>

                </a-table>
              </a-config-provider>
            </a-col>
          </a-row>
        </div>
      </a-collapse-panel>
    </a-collapse>
    <a-collapse :class="'margin-top'" activeKey="1">
      <a-collapse-panel key="1">
        <div class="m-display-flex space-between align-middle" style="justify-content: flex-start" slot="header">
          <h4 class="margin-remove">Reconciliation Transaction Detail</h4>
          <span>&nbsp;[{{ moment(form1.select_periode).format("MM-YYYY") }}]&nbsp;</span>
        </div>
        <a-row :gutter="24">
          <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
            <a-input-search v-model="search" :class="!getScreen ? 'margin-remove' : 'margin-top'"
              placeholder="Search Transaction Detail .. " />
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
            <a-select :class="getScreen ? 'margin-top' : ''" placeholder="Select Type" v-model="searchtype"
              class="width-full" allowClear>
              <a-select-option value="debit">Debit</a-select-option>
              <a-select-option value="credit">Credit</a-select-option>
            </a-select>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 3 }">
            <a-button type="primary" size="default"
              v-if="!isFc"
              :disabled="!bank_rekonsiliasi_hdr_id || closetrans || isFc" @click="handleSaveDraft"
              :loading="loadingDraft">Save Draft
            </a-button>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 3 }">
            <a-button icon="plus" type="primary" size="default"
              v-if="!isFc"
              :disabled="!bank_rekonsiliasi_hdr_id || stspass == 'MATCH' || closetrans || isFc" @click="handleCreate">Create
            </a-button>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :xs="{ span: 24 }" :lg="{ span: 24 }">
            <a-config-provider :locale="getLocalConfigProvider()">
              <a-table :rowKey="(record, index) => { return index; }" key="dtreconcile" size="small" class="margin-top"
                :row-class-name="(_record, index) => (_record.check == '1' ? 'row-checked' : null)" bordered
                :scroll="{ x: 800, y: 500 }" :columns="columns" :dataSource="dtl_temp" :loading="loading"
                :pagination="false">
                <template slot="pass" slot-scope="data">
                  <a-checkbox :checked="data.check == '1' ? true : false" :disabled="action_label == 'Set' || closetrans || isFc"
                    @change="handledatachecked(data.id)"></a-checkbox>
                  <!-- @change="onchangeNilaiTf"
                    :checked="checkTransferValue" -->
                </template>
                <template slot="transactionNumber" slot-scope="data">
                  <span>{{ data.tanggal }}</span><br />
                  <span>{{ data.jenis_transaksi }}</span><br />
                  <a @click="handlelinkmanifest(data.id, data.jenis_transaksi)">{{ data.no_transaksi }}</a>
                </template>
                <template slot="debit" slot-scope="data">
                  <CurrencyJustified :currencyValue="datasource.data_header.currency" :valueNumber="data.debit" />
                </template>
                <template slot="credit" slot-scope="data">
                  <CurrencyJustified :currencyValue="datasource.data_header.currency" :valueNumber="data.kredit" />
                </template>
                <template slot="act" slot-scope="text, data">
                  <!-- <a-button-group> -->
                  <a-button-group>
                    <a-tooltip placement="bottom">
                      <template #title>
                        <span>Edit</span>
                      </template>
                      <a-button v-if="data.jenis_transaksi.toLowerCase() == 'rekonsiliasi'" type="primary"
                        @click="handleeditReconsile(data)" icon="edit" :loading="loading"
                        :disabled="data.check == 1 || action_label == 'Set' || closetrans || isFc">
                      </a-button>
                    </a-tooltip>
                    <a-tooltip placement="bottom">
                      <template #title>
                        <span>Delete</span>
                      </template>
                      <a-button v-if="data.jenis_transaksi.toLowerCase() == 'rekonsiliasi'" type="danger"
                        @click="handledeleteReconsile(data.id)" icon="close"
                        :disabled="data.check == 1 || action_label == 'Set' || closetrans || isFc">
                      </a-button>
                    </a-tooltip>
                    <a-tooltip placement="bottom">
                      <template #title>
                        <span>View Document</span>
                      </template>
                      <a-button v-if="data.jenis_transaksi.toLowerCase() == 'rekonsiliasi'" type="default"
                        @click="handleViewDoc2(data.file_path)" icon="eye" :disabled="!data.file_path">
                      </a-button>
                    </a-tooltip>
                  </a-button-group>
                  <a-tooltip placement="bottom">
                    <template #title>
                      <span>Cancel</span>
                    </template>
                    <a-button type="danger" v-if="data.jenis_transaksi.toLowerCase() == 'bkk'"
                      @click="handlecancelbkk(data)"
                      :disabled="data.cancel_button != 'enabled' || data.check == 1 || closetrans || isFc" icon="stop">
                    </a-button>
                  </a-tooltip>
                  <!-- </a-button-group> -->
                </template>
                <template slot="footer">
                  <a-row :gutter="24" type="flex">
                    <a-col :span="14" :order="1" class="m-text-align left m-text-bold">Reconciliation reference balance in
                      {{ this.UpperEachWord(periode_rekoncile_lbl) }}</a-col>
                    <a-col :span="10" :order="2" class="m-text-align left m-text-bold">
                      <CurrencyJustified :currencyValue="datasource.data_header.currency"
                        :valueNumber="footer_acuan_saldo" :deci2="true" />
                    </a-col>
                  </a-row>
                  <a-row :gutter="24" type="flex">
                    <a-col :span="14" :order="1" class="m-text-align left m-text-bold">Remaining reference balance</a-col>
                    <a-col :span="10" :order="2" class="m-text-align left m-text-bold">
                      <CurrencyJustified :currencyValue="datasource.data_header.currency"
                        :valueNumber="footer_acuan_saldo - footer_dana_efektif" :deci2="true" />
                    </a-col>
                  </a-row>
                  <a-divider class="margin-small"></a-divider>
                  <a-row :gutter="24" type="flex">
                    <a-col :span="14" :order="1" class="m-text-align left">beginning balance in {{
                      this.UpperEachWord(periode_rekoncile_lbl) }}</a-col>
                    <a-col :span="10" :order="2" class="m-text-align left">
                      <CurrencyJustified :currencyValue="datasource.data_header.currency" :valueNumber="footer_awal_saldo"
                        :deci2="true" />
                    </a-col>
                  </a-row>
                  <a-row :gutter="24" type="flex">
                    <a-col :span="14" :order="1" class="m-text-align left">Total debit in {{
                      this.UpperEachWord(periode_rekoncile_lbl) }}</a-col>
                    <a-col :span="10" :order="2" class="m-text-align left">
                      <CurrencyJustified :currencyValue="datasource.data_header.currency" :valueNumber="footer_debit"
                        :deci2="true" />
                    </a-col>
                  </a-row>
                  <a-row :gutter="24" type="flex">
                    <a-col :span="14" :order="1" class="m-text-align left">Total credit in {{
                      this.UpperEachWord(periode_rekoncile_lbl) }}</a-col>
                    <a-col :span="10" :order="2" class="m-text-align left">
                      <CurrencyJustified :currencyValue="datasource.data_header.currency" :valueNumber="footer_credit"
                        :deci2="true" />
                    </a-col>
                  </a-row>
                  <a-divider class="margin-small"></a-divider>
                  <a-row :gutter="24" type="flex">
                    <a-col :span="14" :order="1" class="m-text-align left m-text-bold">balance for {{
                      this.UpperEachWord(periode_rekoncile_lbl) }}</a-col>
                    <a-col :span="10" :order="2" class="m-text-align left m-text-bold">
                      <CurrencyJustified :currencyValue="datasource.data_header.currency"
                        :valueNumber="footer_dana_balance" :deci2="true" />
                    </a-col>
                  </a-row>
                  <a-row :gutter="24" type="flex">
                    <a-col :span="14" :order="1" class="m-text-align left m-text-bold">Effective balance for {{
                      this.UpperEachWord(periode_rekoncile_lbl) }}</a-col>
                    <a-col :span="10" :order="2" class="m-text-align left m-text-bold">
                      <CurrencyJustified :currencyValue="datasource.data_header.currency"
                        :valueNumber="footer_dana_efektif" :deci2="true" />
                    </a-col>
                  </a-row>
                  <a-row :gutter="24" type="flex">
                    <a-col :span="14" :order="1" class="m-text-align left m-text-bold">Bloked Fund for {{
                      this.UpperEachWord(periode_rekoncile_lbl) }}</a-col>
                    <a-col :span="10" :order="2" classStatus="m-text-align left m-text-bold">
                      <CurrencyJustified :currencyValue="datasource.data_header.currency"
                        :valueNumber="footer_dana_blokir" :deci2="true" />
                    </a-col>
                  </a-row>
                </template>
              </a-table>
            </a-config-provider>
          </a-col>
        </a-row>
      </a-collapse-panel>
    </a-collapse>

    <a-modal v-if="modalCreate" v-model="modalCreate" :title="modal.titleModalCreateEdit" :width="500" centered
      :maskClosable="false">
      <a-form :form="formcreate">
        <a-form-item label="Date">
          <a-date-picker v-decorator="['date', { rules: [{ required: true, message: 'please choose the date!' }] }]"
            format="DD-MM-YYYY" />
        </a-form-item>
        <a-form-item label="Description">
          <a-input
            v-decorator="['description', { rules: [{ required: true, message: 'description can\'t be empty!' }] }]" />
        </a-form-item>
        <a-form-item label="Type">
          <a-radio-group buttonStyle="solid"
            v-decorator="['type', { rules: [{ required: true, message: 'type can\'t be empty!' }], initialValue: 'D' }]">
            <a-radio-button value="D">Debit</a-radio-button>
            <a-radio-button value="K">Credit</a-radio-button>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="Value">
          <a-input-number :min="0" class="m-width-full m-text-align right" @keydown="currencyIndonesianFormat"
            :formatter="formatterIndonesianCurrency" :parser="parserIndonesianCurrency"
            v-decorator="['valu', { rules: [{ required: true, message: 'value can\'t be empty!' }] }]"></a-input-number>
        </a-form-item>
        <a-form-item label="Note">
          <a-textarea v-decorator="['note', { rules: [{ required: false, message: 'note can\'t be empty!' }] }]" />
        </a-form-item>
        <a-form-model-item label="Upload File Support" prop="upload_file">
          <a-upload :showUploadList="true" :fileList="push" :beforeUpload="beforeUploadFileSupport"
            :remove="handleRemoveFileSupport" v-decorator="['upload_file_support', { rules: [{ required: false }] }]">
            <a-button> <a-icon type="upload" />&nbsp;Select File </a-button>
          </a-upload>
        </a-form-model-item>
        <a-form-item label="id" hidden>
          <a-input v-decorator="['id', { rules: [{ required: false }] }]" />
        </a-form-item>
        <a-form-item label="Mode" hidden>
          <a-input v-decorator="['mode', { rules: [{ required: true, message: 'mode can\'t be empty!' }] }]" />
        </a-form-item>
      </a-form>
      <template slot="footer">
        <a-button key="back" @click="handleClose"> Cancel </a-button>
        <a-button key="submit" type="primary" @click="handleOk">
          Submit
        </a-button>
      </template>
    </a-modal>

    <a-modal v-if="modalUpload" v-model="modalUpload" title="Upload Attachment" :width="500" centered
      :maskClosable="false">
      <a-form :form="formupload">
        <a-form-item label="Description">
          <a-input v-decorator="['description', { rules: [{ required: true, message: 'description is required!' }] }]" />
        </a-form-item>
        <a-form-item label="Upload Document File">
          <a-upload :showUploadList="true" :beforeUpload="beforeUpload" :remove="handleRemove" v-decorator="[
            'file_list_lampiran',
            { rules: [{ required: true, message: 'upload document file is required!' }] },
          ]" :fileList="fileListLampiran">
            <a-button ref="btndocument" :disabled="fileListLampiran.length > 0" icon="upload">Select File
            </a-button>
          </a-upload>
        </a-form-item>
      </a-form>
      <template slot="footer">
        <a-button key="back" @click="handleCloseupload"> Cancel </a-button>
        <a-button key="submit" type="primary" @click="handleOkupload" :loading="loadingupload">
          Submit
        </a-button>
      </template>
    </a-modal>

    <a-modal v-if="modalRealisasi" v-model="modalRealisasi" title="Change Realization Date BKK" :width="500" centered
      :maskClosable="false">
      <a-form :form="formrealization">
        <a-form-item label="BKK Transaction Number" :hidden="true">
          <a-input v-decorator="['id', { rules: [{ required: true, message: 'ID BKK is required!' }] }]" :hidden="true" />
        </a-form-item>

        <a-form-item label="BKK Transaction Number">
          <a-input v-decorator="['no', { rules: [{ required: true, message: 'BKK Transaction Number is required!' }] }]"
            :disabled="true" />
        </a-form-item>
        <a-form-item label="Realization Date">
          <a-config-provider :locale="getLocalConfigProvider()">
            <a-date-picker placeholder="Select Date" :format="'DD-MM-YYYY'" :allowClear="false"
              :disabled-date="disabledRealizationDate"
              v-decorator="['date', { rules: [{ required: true, message: 'Realization Date is required!' }] }]" />
          </a-config-provider>
        </a-form-item>
      </a-form>
      <template slot="footer">
        <a-button key="back" @click="handleCloseRealization"> Cancel </a-button>
        <a-button key="submit" type="primary" @click="handleOkrealization" :loading="loadingrealization">
          Submit
        </a-button>
      </template>
    </a-modal>
  </a-spin>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import dueDateCalc from "@/mixins/dueDateCalc.js";
import Status from "@/components/Status.vue";
import HandleRoute from "@/mixins/HandleRoute";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import ScreenMixins from "@/mixins/ScreenCheckMixins.js";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import CheckboxAll from "@/components/CheckboxAllHeader.vue";
import _ from "lodash";

export default {
  name: "entri-detil-reconciliation",
  component: { Status, CheckboxAll },
  data() {
    const columns = [
      {
        title: <CheckboxAll />,
        key: "pass",
        scopedSlots: { customRender: "pass" },
        width: 50,
        align: "center",
      },
      {
        title: "Date / Type /Transaction Number",
        key: "transactionNumber",
        scopedSlots: { customRender: "transactionNumber" },
        width: 200,
      },
      {
        title: "Description",
        key: "description",
        width: 300,
        dataIndex: "deskripsi",
      },
      {
        title: "Debit",
        key: "debit",
        width: 150,
        scopedSlots: { customRender: "debit" },
      },
      {
        title: "Credit",
        key: "credit",
        width: 150,
        scopedSlots: { customRender: "credit" },
      },
      {
        title: "Action",
        key: "act",
        scopedSlots: { customRender: "act" },
        width: 120,
        align: "center",
      },
    ];
    const columnsBKKNotReleazed = [
      {
        title: "Date / Type /Transaction Number",
        key: "bkknotrealizedNumber",
        scopedSlots: { customRender: "bkknotrealizedNumber" },
        width: 200,
      },
      {
        title: "Description",
        key: "description",
        width: 200,
        dataIndex: "description",
      },
      {
        title: "Value",
        key: "value",
        width: 150,
        scopedSlots: { customRender: "value" },
      },
      {
        title: "Due Date",
        key: "duedate",
        width: 100,
        align: "center",
        scopedSlots: { customRender: "duedate" },
      },
      {
        title: "Action",
        key: "act",
        scopedSlots: { customRender: "act" },
        width: 180,
        align: "center",
      },
    ]
    return {
      urllogo: this.$serviceUrl,
      urllogonotfound: '"' + this.$serviceUrl + 'assets/bank/not-found.png"',
      datasource: {
        data_header: {
          nama_bank: null,
          pemilik: null,
          kode_rekening: null,
          periode: null,
          currency: "IDR",
          close_sts: null
        }
      },
      dtl_temp: [],
      search: undefined,
      searchtype: undefined,
      searchBkk: undefined,
      columns,
      columnsBKKNotReleazed,
      databkknotrealized: [],
      databkknotrealizedtmp: [],
      pageLoading: false,
      loading: false,
      loadingupload: false,
      loadingrealization: false,
      loadingclose: false,
      loadingcancel: false,
      loadingDraft: false,
      form1: {
        select_periode: undefined,
        trans_date: undefined,
        start_balance: null,
        reference_balance: null,
      },
      rules1: {
        select_periode: [
          {
            required: false,
            trigger: "blur",
          },
        ],
        trans_date: [
          {
            required: false,
            trigger: "blur",
          },
        ],
        start_balance: [{
          required: false,
          trigger: "blur",
        },],
        reference_balance: [{
          required: false,
          trigger: "blur",
        },],
      },
      bank_rekonsiliasi_hdr_id: null,
      periode_rekoncile_lbl: moment().format("MMMM YYYY").toLowerCase(),
      footer_acuan_saldo: 0,
      footer_awal_saldo: 0,
      footer_dana_blokir: 0,
      footer_debit: 0,
      footer_credit: 0,
      modalCreate: false,
      modalUpload: false,
      modalRealisasi: false,
      fileListLampiran: [],
      minselect_periode: null,
      maxselect_periode: null,
      wasChecked: 0,
      modal: {
        titleModalCreateEdit: '',
      },
      push: [],
    };
  },
  mixins: [dueDateCalc, HandleRoute, CurrencyFormat, ScreenMixins, GlobalMethod],
  beforeCreate() {
    this.formcreate = this.$form.createForm(this);
    this.formupload = this.$form.createForm(this);
    this.formrealization = this.$form.createForm(this);
  },
  created() {
    this.fetch();
  },
  mounted() {
    Event.$on("checkboxallselectReturn", this.handlecheckall);
  },
  beforeDestroy() {
    Event.$off("checkboxallselectReturn", this.handlecheckall);
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getDefaultDateFormat",
      "getAuth",
    ]),
    footer_dana_balance() {
      return ((this.footer_awal_saldo + this.footer_credit) - this.footer_debit).toFixed(2);
    },
    footer_dana_efektif() {
      return this.footer_dana_balance - this.footer_dana_blokir;
    },
    stspass() {
      if (this.footer_acuan_saldo == this.footer_dana_balance &&
        (this.footer_acuan_saldo > 0 && this.footer_dana_balance > 0) &&
        this.wasChecked > 0 && this.action_label == 'Change') {
        return "MATCH";
      } else {
        return "NOT MATCH";
      }
    },
    action_label() {
      return this.bank_rekonsiliasi_hdr_id != null ? 'Change' : 'Set';
    },
    disabledstartbalance() {
      //console.log(this.action_label=='Change', moment(this.minselect_periode).format("YYYY-MM"),moment(this.form1.select_periode).format('YYYY-MM') )
      // return ((this.action_label == 'Change' ||
      //   (this.minselect_periode != null &&
      //     moment(this.minselect_periode).format("YYYY-MM") != moment(this.form1.select_periode).format('YYYY-MM')))
      //   && this.datasource.data_header.start_balance > 0);
      return (this.action_label == 'Change' || this.datasource.data_header.saldo_awal_bank_account != null);
    },
    closetrans() {
      return this.datasource.data_header.close_sts == '1' ? true : false;
    },
    isFc(){
      return this.$route.path.includes('/financialControl')?true:false
    }
  },
  watch: {
    search() {
      if (this.search) {
        this.filterdatadtltemp();
      } else {
        this.dtl_temp = this.datasource.data_dtl;
      }
    },
    searchtype() {
      if (this.searchtype) {
        this.filterdatadtltemp();
      } else {
        this.dtl_temp = this.datasource.data_dtl;
      }
    },
    searchBkk() {
      if (this.searchBkk) {
        this.filterdatabkknotrealized();
      } else {
        this.databkknotrealizedtmp = this.databkknotrealized;
      }
    },
    dtl_temp() {
      this.tablewatchvalue();
    },
    bank_rekonsiliasi_hdr_id() {
      if (!this.bank_rekonsiliasi_hdr_id || this.stspass == 'MATCH') {
        Event.$emit("setdisabledcheckboxallselect", true);
      } else {
        Event.$emit("setdisabledcheckboxallselect", false);
      }
    }
  },
  methods: {
    moment,
    fetch() {
      this.pageLoading = true;
      this.$store
        .dispatch("getDataReconcile", { auth: this.getAuth, id: this.$attrs.id })
        .then((res) => {
          this.datasource.data_header = res.header[0];
          this.minselect_periode = moment(res.min_periode, "YYYY-MM");
          this.maxselect_periode = moment(res.max_periode, "YYYY-MM");
          this.databkknotrealized = res.bkk_not_realized;
          this.databkknotrealizedtmp = res.bkk_not_realized;
          this.datasource.data_dtl = res.dtl;
          this.dtl_temp = this.datasource.data_dtl;
          if (this.datasource.data_dtl.length > 0) {
            if (this.dtl_temp.length > 0 || res.header[0].close_sts == '1') {
              _.forEach(this.dtl_temp, item => {
                let indx = _.findIndex(this.datasource.data_dtl, (e) => {
                  return e.id == item.id;
                }, 0);

                if (indx >= 0) {
                  this.datasource.data_dtl[indx].check = item.check;
                }
              });
            } else {
              _.forEach(this.datasource.data_dtl, item => {
                item.check = "0";
              });
            }
            this.dtl_temp = this.datasource.data_dtl;
          }
          this.datasource.file_attachment = res.file;
          this.form1.select_periode = moment(res.header[0].periode, 'YYYY-MM');
          this.form1.trans_date = res.header[0].trans_date ? moment(res.header[0].trans_date, 'YYYY-MM-DD') :
            (res.header[0].periode ? moment(res.header[0].periode).subtract(-1, 'months') : moment(this.form1.select_periode).subtract(-1, 'months'));
          this.form1.start_balance = res.saldo_awal;
          this.form1.reference_balance = res.saldo_acuan_rekon;
          this.periode_rekoncile_lbl = moment(res.periode, "YYYY-MM").format("MMMM YYYY").toLowerCase();
          if (res.saldo_awal && res.saldo_awal > 0) {
            if (res.header[0].close_sts != '1') {
              this.bank_rekonsiliasi_hdr_id = res.header[0].bank_rekonsiliasi_hdr_id;
            } else {
              this.bank_rekonsiliasi_hdr_id = null;
            }
            this.sumcheckedvalue();
          }

          this.footer_acuan_saldo = res.saldo_acuan_rekon;
          this.footer_awal_saldo = res.saldo_awal;
          this.footer_dana_blokir = res.dana_blokir;

          this.pageLoading = false;
        });
    },
    handleDocument(item) {
      const data = {
        rest_api: item.rest_api.toLowerCase(),
        id_manifest: item.id_manifest,
        tlc: this.getAuth.username,
        user_pembuat: item.user_pembuat,
      };
      this.handleView(data);
    },
    handleViewDoc() {
      window.open(this.$serviceUrl + this.datasource.data_header.link);
    },
    handleViewDoc2(path) {
      window.open(this.$serviceUrl + path);
    },
    handleChangePeriode() {
      this.pageLoading = true;
      this.bank_rekonsiliasi_hdr_id = null;
      this.$store
        .dispatch("getReconcilePeriode", {
          auth: this.getAuth,
          param: {
            id: this.$attrs.id,
            tlc: this.getAuth.username,
            periode: moment(this.form1.select_periode).format('YYYY-MM-DD'),
          }
        })
        .then((res) => {
          this.datasource.data_header = res.header[0];
          this.minselect_periode = moment(res.min_periode, "YYYY-MM");
          // this.maxselect_periode = res.header[0].close_sts!=null &&  res.header[0].close_sts=="1" ? 
          //   moment(res.max_periode,"YYYY-MM").add(1, 'month') : moment(res.max_periode,"YYYY-MM");
          this.maxselect_periode = moment(res.max_periode, "YYYY-MM")
          this.form1.trans_date = moment(res.header[0].trans_date ? res.header[0].trans_date :
            (res.header[0].periode ? res.header[0].periode : moment(this.form1.select_periode).subtract(-1, 'months')), 'YYYY-MM-DD');
          this.periode_rekoncile_lbl = moment(this.form1.select_periode).format("MMMM YYYY").toLowerCase();
          this.datasource.file_attachment = res.file;
          this.datasource.data_dtl = res.dtl;
          this.databkknotrealized = res.bkk_not_realized;
          this.databkknotrealizedtmp = res.bkk_not_realized;
          if (this.dtl_temp.length > 0) {
            _.forEach(this.dtl_temp, item => {
              let indx = _.findIndex(this.datasource.data_dtl, (e) => {
                return e.id == item.id;
              }, 0);

              if (indx >= 0) {
                this.datasource.data_dtl[indx].check = item.check;
              }
            });
          }
          // else {
          //   _.forEach(this.datasource.data_dtl, item => { 
          //     item.check = "0";
          //   });
          // }
          this.dtl_temp = this.datasource.data_dtl;
          this.sumcheckedvalue();

          this.footer_acuan_saldo = res.saldo_acuan_rekon;
          this.footer_awal_saldo = res.saldo_awal;
          this.footer_dana_blokir = res.dana_blokir;

          this.form1.start_balance = res.saldo_awal;
          this.form1.reference_balance = res.saldo_acuan_rekon;

          if (res.saldo_awal && res.saldo_awal > 0) {
            this.bank_rekonsiliasi_hdr_id = res.header[0].bank_rekonsiliasi_hdr_id;
          }

          //reset filter
          this.search = undefined;
          this.searchtype = undefined;

          this.pageLoading = false;
        }).catch((err) => {
          let responses = Object.assign({}, err.response.data);
          if (responses.message && responses.status == false) {
            this.displayMessageValue("error-other", responses.message);
          } else {
            this.displayMessageValue("error", responses);
          }
          this.fetch();
        });
    },
    handleSet() {
      // if (this.form1.start_balance <= 0) {
      //   this.displayMessageValue("error-other", "Start Balance must be greather then 0!");
      //   return;
      // }

      // if (this.form1.reference_balance<=0){
      //   this.displayMessageValue("error-other", "Reference Balance must be greather then 0!");
      //   return;
      // }

      if (this.action_label == "Change") {
        this.bank_rekonsiliasi_hdr_id = null;
      } else {
        this.loadDatadtl();
      }
    },
    loadDatadtl() {
      this.pageLoading = true;
      this.$store
        .dispatch("getReconcilePeriode", {
          auth: this.getAuth,
          param: {
            id: this.$attrs.id,
            tlc: this.getAuth.username,
            periode: moment(this.form1.select_periode).format('YYYY-MM-DD'),
            balance: this.form1.start_balance,
            saldo: this.form1.reference_balance,
            trans_date: moment(this.form1.trans_date).format('YYYY-MM-DD'),
          }
        })
        .then((res) => {
          this.databkknotrealized = res.bkk_not_realized;
          this.databkknotrealizedtmp = res.bkk_not_realized;
          this.datasource.data_header.close_sts = res.header[0].close_sts;
          this.datasource.data_header.start_balance = res.header[0].start_balance;
          this.minselect_periode = moment(res.min_periode, 'YYYY-MM');
          this.maxselect_periode = moment(res.max_periode, "YYYY-MM");
          this.form1.trans_date = moment(res.header[0].trans_date ? res.header[0].trans_date : res.header[0].periode, 'YYYY-MM-DD');
          if (res.header[0].close_sts != '1') {
            this.bank_rekonsiliasi_hdr_id = res.header[0].bank_rekonsiliasi_hdr_id;
          } else {
            this.bank_rekonsiliasi_hdr_id = null;
          }
          this.periode_rekoncile_lbl = moment(res.periode, "YYYY-MM").format("MMMM YYYY").toLowerCase()
          this.datasource.file_attachment = res.file;
          this.datasource.data_dtl = res.dtl;
          if (this.dtl_temp.length > 0 || res.header[0].close_sts == '1') {
            _.forEach(this.dtl_temp, item => {
              let indx = _.findIndex(this.datasource.data_dtl, (e) => {
                return e.id == item.id;
              }, 0);

              if (indx >= 0) {
                this.datasource.data_dtl[indx].check = item.check;
              }
            });
          } else {
            _.forEach(this.datasource.data_dtl, item => {
              item.check = "0";
            });
          }
          this.dtl_temp = this.datasource.data_dtl;
          this.sumcheckedvalue();

          this.footer_acuan_saldo = res.saldo_acuan_rekon;
          this.footer_awal_saldo = res.saldo_awal;
          this.footer_dana_blokir = res.dana_blokir;

          this.push = []

          this.pageLoading = false;
        }).catch((err) => {
          let responses = Object.assign({}, err.response.data);
          if (responses.message && responses.status == false) {
            this.displayMessageValue("error-other", responses.message);
          } else {
            this.displayMessageValue("error", responses);
          }
          this.fetch();
        });
    },
    handleCreate() {
      this.modalCreate = true;
      this.modal.titleModalCreateEdit = "Create Bank Reconciliation"
      this.$nextTick(function () {
        this.formcreate.setFieldsValue({
          date: moment(this.form1.select_periode),
          mode: "create"
        });
      });
    },
    handleeditReconsile(data) {
      this.loading = true;
      this.$store
        .dispatch("getDataEditReconcile", { auth: this.getAuth, id: data.id })
        .then((res) => {
          this.modalCreate = true;
          this.modal.titleModalCreateEdit = "Edit Bank Reconciliation"

          if (res.data[0].file_upload) {
            let typefile = this.fileTypeFromUrl(res.data[0].file_name);
            let file = this.dataURLtoFile(
              typefile + res.data[0].file_support,
              res.data[0].file_name
            );
            file.uid = "vc-upload-1-1";
            file.status = "done";
            file.url = this.$serviceUrl + res.data[0].file_path;
            this.push = [file];
          }

          this.$nextTick(function () {
            this.formcreate.setFieldsValue({
              date: moment(res.data[0].trans_dt),
              description: res.data[0].description,
              type: res.data[0].type_value,
              valu: res.data[0].value,
              note: res.data[0].catatan,
              id: res.data[0].bank_rekonsiliasi_id,
              mode: "edit"
            });
          });
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          let responses = Object.assign({}, err.response.data);
          if (responses.message && responses.status == false) {
            this.displayMessageValue("error-other", responses.message);
          } else {
            this.displayMessageValue("error", responses);
          }
        });
    },
    handleClose() {
      this.formcreate.resetFields();
      this.$refs.file = null;
      this.modalCreate = false;
    },
    handleOk() {
      this.formcreate.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        let formData = new FormData();
        if (values.mode == "create") {
          formData.append("tlc", this.getAuth.username);
          formData.append("date", moment(values.date).format('YYYY-MM-DD'));
          formData.append("bank_account", this.$attrs.id);
          formData.append("type_transaction", values.type);
          formData.append("description", values.description);
          formData.append("value", values.valu);
          formData.append("note", values.note ? values.note : '');
          formData.append("bank_rekonsiliasi_hdr_id", this.bank_rekonsiliasi_hdr_id);
          formData.append("upload_file_support", this.push[0]);
        } else {
          formData.append("bank_reconcile_id", values.id);
          formData.append("tlc", this.getAuth.username);
          formData.append("date", moment(values.date).format('YYYY-MM-DD'));
          formData.append("description", values.description);
          formData.append("type_transaction", values.type);
          formData.append("value", values.valu);
          formData.append("note", values.note ? values.note : '');
          formData.append("upload_file_support", this.push[0]);
        }

        this.loading = true;
        this.$store.dispatch(values.mode == "create" ? "createReconcile" : "editReconcile", {
          auth: this.getAuth,
          params: formData
        })
          .then((res) => {
            if (res.data.status == true) {
              // this.displayMessageValue("success-other", res.data.message);
              // this.resetForm();
              // this.$nextTick(() => {
              //   this.form.file = undefined;
              // });
              // this.handleReload();
              this.loadDatadtl();
            } else {
              this.displayMessageValue(
                "error-other",
                res.data.message
              );
            }
            this.sumcheckedvalue();
            this.loading = false;

          })
          .catch(err => {
            console.log("err", err);
            this.loading = false;
          });
        this.modalCreate = false;
      });
    },
    filterdatadtltemp() {
      if (this.search) {
        this.dtl_temp = _.filter(this.datasource.data_dtl,
          (nav) =>
            (nav.no_transaksi &&
              nav.no_transaksi
                .toLowerCase()
                .indexOf(this.search.toLowerCase()) >= 0) ||
            (nav.jenis_transaksi &&
              nav.jenis_transaksi
                .toLowerCase()
                .indexOf(this.search.toLowerCase()) >= 0) ||
            (nav.deskripsi &&
              nav.deskripsi
                .toLowerCase()
                .indexOf(this.search.toLowerCase()) >= 0) ||
            (nav.tanggal &&
              nav.tanggal
                .toLowerCase()
                .indexOf(this.search.toLowerCase()) >= 0)
        );
      } else {
        this.dtl_temp = this.datasource.data_dtl;
      }

      if (this.searchtype == "debit") {
        this.dtl_temp = _.filter(this.dtl_temp,
          (nav) =>
          (nav.debit &&
            Number(nav.debit) > 0)
        );
      }
      if (this.searchtype == "credit") {
        this.dtl_temp = _.filter(this.dtl_temp,
          (nav) =>
          (nav.kredit &&
            Number(nav.kredit) > 0)
        );
      }
    },
    filterdatabkknotrealized() {
      if (this.searchBkk) {
        this.databkknotrealizedtmp = _.filter(this.databkknotrealized,
          (nav) =>
            (nav.no_bkk &&
              nav.no_bkk
                .toLowerCase()
                .indexOf(this.searchBkk.toLowerCase()) >= 0) ||
            (nav.jenis &&
              nav.jenis
                .toLowerCase()
                .indexOf(this.searchBkk.toLowerCase()) >= 0) ||
            (nav.description &&
              nav.description
                .toLowerCase()
                .indexOf(this.searchBkk.toLowerCase()) >= 0) ||
            (nav.create_dt &&
              moment(nav.create_dt).format(this.getDefaultDateFormat)
                .toLowerCase()
                .indexOf(this.searchBkk.toLowerCase()) >= 0)
        );
      } else {
        this.databkknotrealizedtmp = this.databkknotrealized;
      }
    },
    handleeditRealization(val) {
      this.modalRealisasi = true;
      this.$nextTick(() => {
        this.formrealization.setFieldsValue({
          id: val.bkk_id,
          no: val.no_bkk,
          date: val.realisasi_dt ? moment(val.realisasi_dt) : null
        });
      });
    },
    handledeleteReconsile(val) {
      this.loading = true;
      let formData = new FormData();
      formData.append("tlc", this.getAuth.username);
      formData.append("id", val);
      this.$store.dispatch("deleteReconcile", {
        auth: this.getAuth,
        params: formData
      })
        .then((res) => {
          if (res.data.status == true) {
            // this.displayMessageValue("success-other", res.data.message);
            // this.resetForm();
            // this.$nextTick(() => {
            //   this.form.file = undefined;
            // });
            // this.handleReload();
            this.loadDatadtl();
          } else {
            this.displayMessageValue(
              "error-other",
              res.data.message
            );
          }
          this.loading = false;

        })
        .catch(err => {
          console.log("err", err);
          this.loading = false;
        });
    },
    handledatachecked(id) {
      _.forEach(this.datasource.data_dtl, item => {
        if (item.id == id) {
          if (item.check == 1) {
            item.check = 0;
          } else {
            item.check = 1;
          }
        }
      });
      this.sumcheckedvalue();
      this.tablewatchvalue();
    },
    handlecheckall(val) {
      //console.log(val);
      _.forEach(this.dtl_temp, item => {
        item.check = val;
        this.datasource.data_dtl[_.findIndex(this.datasource.data_dtl, (e) => {
          return e.id == item.id;
        }, 0)].check = val;
      })
      this.sumcheckedvalue();
    },
    sumcheckedvalue() {
      this.wasChecked = _.sumBy(this.datasource.data_dtl, function (val) {
        return val.check == "1" ? 1 : 0;
      });

      this.footer_debit = this.datasource.data_dtl.length > 0 ?
        _.sumBy(this.datasource.data_dtl, function (val) {
          return val.check == "1" ? Number(val.debit) : 0;
        }) : 0;
      this.footer_credit = this.datasource.data_dtl.length > 0 ? _.sumBy(this.datasource.data_dtl, function (val) {
        return val.check == "1" ? Number(val.kredit) : 0;
      }) : 0;
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
        this.fileListLampiran.push(file);
        return false;
      }
    },
    handleRemove(file) {
      const index = this.fileListLampiran.indexOf(file);
      const newFileList = this.fileListLampiran.slice();
      newFileList.splice(index, 1);
      this.fileListLampiran = newFileList;
    },
    beforeUploadFileSupport(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
        this.push.push(file);
        return false;
      }
    },
    handleRemoveFileSupport() {
      this.push = [];
    },
    handleupload() {
      this.modalUpload = true;
    },
    handleCloseupload() {
      this.modalUpload = false;
      this.fileListLampiran = [];
    },
    handleCloseRealization() {
      this.modalRealisasi = false;
    },
    handleOkupload() {
      this.formupload.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        this.loadingupload = true;
        let formData = new FormData();
        formData.append("tlc", this.getAuth.username);
        formData.append("bank_rekonsiliasi_hdr_id", this.bank_rekonsiliasi_hdr_id);
        formData.append("document_description", values.description);
        formData.append("upload_file", this.fileListLampiran[0]);
        this.$store.dispatch("uploadLampiranReconcile", {
          auth: this.getAuth,
          params: formData
        })
          .then((res) => {
            if (res.data.status == true) {
              // this.displayMessageValue("success-other", res.data.message);
              // this.resetForm();
              // this.$nextTick(() => {
              //   this.form.file = undefined;
              // });
              // this.handleReload();
              this.fileListLampiran = [];
              this.loadDatadtl();
            } else {
              this.displayMessageValue(
                "error-other",
                res.data.message
              );
            }
            this.modalUpload = false;
            this.loadingupload = false;

          })
          .catch(err => {
            console.log("err", err);
            this.loadingupload = false;
          });
      });
    },
    handleOkrealization() {
      this.formrealization.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        this.loadingrealization = true;
        let formData = new FormData();
        formData.append("tlc", this.getAuth.username);
        formData.append("id", values.id);
        formData.append("date", moment(values.date).format("YYYY-MM-DD"));

        this.$store.dispatch("updateDateBKKRealization", {
          auth: this.getAuth,
          params: formData
        })
          .then((res) => {
            if (res.data.status == true) {
              this.loadDatadtl();
            } else {
              this.displayMessageValue(
                "error-other",
                res.data.message
              );
            }
            this.modalRealisasi = false;
            this.loadingrealization = false;

          })
          .catch(err => {
            console.log("err", err);
            this.loadingrealization = false;
          });
      });
    },
    handleviewfile(file_url) {
      window.open(this.$serviceUrl + file_url);
    },
    handleCloseReconsile() {
      let unselected = _.filter(this.datasource.data_dtl,
        (nav) =>
          (nav.jenis_transaksi == 'BKK' && nav.cancel_button != 'enabled' && nav.check == "0") ||
          (nav.jenis_transaksi !== 'BKK' && nav.check == "0")
      );
      console.log(unselected)
      if (unselected.length > 0) {
        this.displayMessageValue(
          "error-other",
          "There is still unverified data! \r\n look at data unchecked on BKK ATM Transactions or besides it!."
        );
      } else if (this.datasource.file_attachment.length == 0) {
        this.displayMessageValue(
          "error-other",
          "Attachment file is empty!"
        );
      } else {
        this.loadingclose = true;
        // let formData = new FormData();
        // formData.append("tlc",this.getAuth.username);
        // formData.append("bank_rekonsiliasi_hdr_id", this.bank_rekonsiliasi_hdr_id);
        let selectedItems = [];
        let unselectedItems = [];
        _.forEach(this.datasource.data_dtl, item => {
          if (item.check == "1") {
            selectedItems.push({
              jenis_transaksi: item.jenis_transaksi,
              id: item.id
            });
          }
          if (item.jenis_transaksi == 'BKK' && item.check == '0') {
            unselectedItems.push({
              jenis_transaksi: item.jenis_transaksi,
              id: item.id
            });
          }
        });
        let formData = {
          tlc: this.getAuth.username,
          bank_rekonsiliasi_hdr_id: this.bank_rekonsiliasi_hdr_id,
          selected_item: selectedItems,
          unselected_item: unselectedItems
        }

        this.$store.dispatch("closeReconcile", {
          auth: this.getAuth,
          params: formData
        })
          .then((res) => {
            if (res.data.status == true) {
              // this.displayMessageValue("success-other", res.data.message);
              // this.resetForm();
              // this.$nextTick(() => {
              //   this.form.file = undefined;
              // });
              // this.handleReload();
              this.loadDatadtl();
            } else {
              this.displayMessageValue(
                "error-other",
                res.data.message
              );
            }
            this.loadingclose = false;

          })
          .catch(err => {
            console.log("err", err);
            this.loadingclose = false;
          });
      }
    },
    handlelinkmanifest(id, transaction) {
      let newtab = true;
      let val = {
        id_manifest: id,
        rest_api: transaction.toLowerCase()
      }
      this.handleView(val, newtab);
    },
    tablewatchvalue() {
      if (this.dtl_temp.length > 0) {
        let jml_data = this.dtl_temp.length;
        let selected = _.filter(this.dtl_temp,
          (nav) =>
            (nav.check == 1)
        );
        if (jml_data == selected.length) {
          Event.$emit("setvalcheckboxallselect", true);
        } else {
          Event.$emit("setvalcheckboxallselect", false);
        }
      }
    },
    disabledMinDate(current) {
      // Can not select days before today and today
      // return (this.minselect_periode ? 
      //   current && current < moment(this.minselect_periode).subtract(0, 'months') :
      //   false) ||
      //   (this.maxselect_periode ? 
      //   current && current > moment(this.maxselect_periode).subtract(0, 'months') :
      //   false);
      return false
    },
    disabledTrans_date(current) {
      // Can not select days before today and today
      return (this.form1.select_periode ?
        current < moment(this.form1.select_periode).subtract(-1, 'months') :
        false) || (this.form1.select_periode ?
          current > moment(this.form1.select_periode).subtract(-2, 'months') :
          false);
    },
    disabledRealizationDate(current) {
      return (this.maxselect_periode ?
        current && current < moment(this.maxselect_periode).startOf('month') :
        false) ||
        (this.maxselect_periode ?
          current && current > moment(this.maxselect_periode).endOf('months') :
          false);
    },
    handlecancelbkk(val) {
      this.loadingcancel = true;
      let formData = new FormData();
      formData.append("tlc", this.getAuth.username);
      formData.append("id", val.id);
      this.$store.dispatch("cancelReconcile", {
        auth: this.getAuth,
        params: formData
      })
        .then((res) => {
          if (res.data.status == true) {
            // this.displayMessageValue("success-other", res.data.message);
            // this.resetForm();
            // this.$nextTick(() => {
            //   this.form.file = undefined;
            // });
            // this.handleReload();
            //this.handleSet();
            this.loadDatadtl();
          } else {
            this.displayMessageValue(
              "error-other",
              res.data.message
            );
          }
          this.loadingcancel = false;
        })
        .catch(err => {
          console.log("err", err);
          this.loadingcancel = false;
        });
    },
    handleSaveDraft() {
      let selectedItems = [];
      _.forEach(this.datasource.data_dtl, item => {
        if (item.check == "1") {
          selectedItems.push({
            jenis_transaksi: item.jenis_transaksi,
            id: item.id
          });
        }
      });
      let formData = {
        tlc: this.getAuth.username,
        bank_rekonsiliasi_hdr_id: this.bank_rekonsiliasi_hdr_id,
        selected_item: selectedItems,
      }

      this.loadingDraft = true;
      this.$store.dispatch("draftReconcile", {
        auth: this.getAuth,
        params: formData
      })
        .then((res) => {
          if (res.data.status == true) {
            // this.displayMessageValue("success-other", res.data.message);
            // this.resetForm();
            // this.$nextTick(() => {
            //   this.form.file = undefined;
            // });
            // this.handleReload();
            //this.loadDatadtl();
            this.displayMessageValue("success-other", "Success to save Draft!");
          } else {
            this.displayMessageValue(
              "error-other",
              res.data.message
            );
          }
          this.loadingDraft = false;

        })
        .catch(err => {
          this.loadingDraft = false;
          let responses = Object.assign({}, err.response.data);
          if (responses.message && responses.status == false) {
            this.displayMessageValue("error-other", responses.message);
          } else {
            this.displayMessageValue("error", responses);
          }
        });
    },
    handleRemoveExisting(id) {
      let formData = new FormData();
      formData.append("id", id);
      this.$store.dispatch("RemoveuploadLampiranReconcile", {
        auth: this.getAuth,
        params: formData
      })
        .then((res) => {
          if (res.data.status == true) {
            this.loadDatadtl();
          } else {
            this.displayMessageValue(
              "error-other",
              res.data.message
            );
          }
        })
        .catch(err => {
          console.log("err", err);
        });
    }
  },
};
</script>

<style>
.row-checked {
  color: rgba(0, 0, 0, 0.45);
  background: #f7f9fb;
}
</style>
